module.exports = __webpack_public_path__ + "static/media/tipspackaging60.0beac727.png";